<template>
  <div class="platform-comment" v-loading="loading">
    <div
      class="platform-comment-select"
      v-show="mode !== 'checkbox' && !loading"
    >
      <div class="platform-comment-title">{{ title }}</div>
      <div class="platform-comment-desc">{{ description }}</div>
      <!-- 编辑模式 -->
      <div class="platform-comment-list" v-show="mode === 'edit'">
        <div
          class="platform-comment-item"
          v-for="(item, index) in selectOptions"
          :key="index"
          @click="handleSelect(item, index)"
        >
          <img class="platform-comment-icon" :src="item.icon" />
          <span class="platform-comment-text">{{ item.text }}</span>
        </div>
      </div>

      <!-- 展示模式 -->
      <div class="platform-comment-select" v-show="mode === 'preview'">
        <img class="platform-comment-icon" :src="selectComment.icon" />
        <span class="platform-comment-text">{{ selectComment.text }}</span>
        <span class="platform-comment-editBtn" @click="handleChangeMode('edit')"
          >修改</span
        >
      </div>
    </div>

    <div class="platform-comment-checkbox" v-show="mode === 'checkbox'">
      <i
        class="comment-form-close el-icon-circle-close"
        @click="handleChangeMode('edit')"
      ></i>
      <div class="platform-comment-title">{{ dialogTitle }}</div>
      <el-form :model="formData" class="demo-form-inline">
        <el-checkbox-group v-model="formData.checkList">
          <el-checkbox
            :label="item"
            class="comment-form-item"
            v-for="(item, index) in optionArr"
            :key="index"
          ></el-checkbox>
        </el-checkbox-group>
        <div class="comment-form-item btn-container">
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script type="text/javascript">
import plusService from "@/global/services/jikerPlus";

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    sourceId: {
      type: [Number, String],
      required: true
    },
    projectId: {
      type: [Number, String]
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    selectOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      mode: "",
      selectComment: {},
      formData: {
        checkList: []
      },
      dialogTitle: "",
      optionArr: [],
      selectItem: {}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      plusService
        .logQuery({
          source: "kongfu",
          source_id: this.sourceId,
          event: "widget.evaluate",
          "content[widget_id]": this.id
        })
        .then(res => {
          if (res.id) {
            const selectIndex = res.content.select_index;
            this.mode = "preview";
            this.selectComment.text = res.content.select;
            this.selectComment.icon = this.selectOptions[selectIndex].icon;
          } else {
            this.mode = "edit";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChangeMode(mode) {
      this.mode = mode;
      this.formData.checkList = [];
    },
    handleSelect(item, index) {
      this.selectItem = item;
      this.selectItem.select_index = index;
      this.dialogTitle = item.dialogTitle;
      this.optionArr = item.optionArr;
      this.handleChangeMode("checkbox");
    },
    handleSubmit() {
      this.selectComment.icon = this.selectItem.icon;
      this.selectComment.text = this.selectItem.text;
      const content = {
        source_id: this.sourceId,
        widget_id: this.id,
        title: this.title,
        select: this.selectItem.text,
        select_index: this.selectItem.select_index,
        select_detail: this.formData.checkList
      };
      plusService
        .logs({
          source: "kongfu",
          event: "widget.evaluate",
          source_id: this.sourceId,
          content
        })
        .then(() => {
          this.mode = "preview";
        });
    }
  }
};
</script>

<style type="text/css" lang="less" scoped>
.platform-comment {
  position: relative;
  padding: 25px;
  text-align: center;
  background: #eaf9f4;
  margin: 20px 0;
  .platform-comment-title {
    margin-bottom: 15px;
    font-size: 18px;
    line-height: 24px;
    color: #333;
  }
  .platform-comment-desc {
    margin-bottom: 15px;
    font-size: 13px;
    line-height: 25px;
    white-space: pre-line;
  }

  .platform-comment-checkbox {
    text-align: left;
    padding: 0 16px;
    display: inline-block;
    .comment-form-close {
      position: absolute;
      top: 14px;
      right: 14px;
      cursor: pointer;
    }
    .comment-form-item {
      display: block;
      margin: 10px 0;
      &.btn-container {
        margin-top: 24px;
        text-align: center;
      }
    }
  }

  .platform-comment-list {
    display: flex;
    justify-content: center;

    .platform-comment-item {
      margin: 0 10px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      .platform-comment-icon {
        display: block;
        margin: 0 auto 10px;
        height: 35px;
        width: 35px;
        // max-width: 90px;
        background-color: #f1f1f1;
      }
      .platform-comment-text {
        font-size: 14px;
        color: #333;
        line-height: 18px;
        max-width: 90px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .platform-comment-select {
    .platform-comment-icon {
      display: inline-block;
      vertical-align: middle;
      height: 35px;
      width: 35px;
      margin-right: 10px;
      background-color: #f1f1f1;
    }
    .platform-comment-text {
      vertical-align: middle;
      display: inline-block;
      font-size: 14px;
      color: #333;
      line-height: 18px;
    }
  }

  .platform-comment-editBtn {
    position: absolute;
    bottom: 20px;
    right: 25px;
    font-size: 13px;
    color: #000;
    text-decoration: underline;
    transition: all 0.2s;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
